import { Pagination } from 'antd';
import download from 'downloadjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../../api';
import { RootState } from '../../../../../store/RootReducer';
import { commaSeperator } from '../../../../../utils/Validation';
import PCard from '../../../../common/Card';
import PTable from '../../../../common/Table';
import MessageActions from '../../../../message/redux/actions';
import OverAllReportAction from '../redux/actions';

type Props = {
    startDate: any;
    endDate: any;
};

const SitePerformanceTable: React.FC<Props> = ({ startDate, endDate }) => {
    const dispatch = useDispatch();
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const totalRecords = useSelector((state: RootState) => state.report.totalSiteListRecords);
    const campList = useSelector((state: RootState) => state.report.reportsSiteList);
    const campListLoader = useSelector((state: RootState) => state.report.reportsSiteListLoader);

    const [downloadLoader, setDownloadLoader] = useState<boolean>(false);
    const columnData = [
        {
            title: 'Site Name',
            dataIndex: 'name',
            width: 280,
            fixed: 'left',
            render: (text: string, row: any) => <div className="underline">{text}</div>,
        },
        {
            title: 'Budget Spent',
            dataIndex: 'budget_spent',
            render: (text: any) => <div className="flex justify-end">${commaSeperator(parseFloat(text).toFixed(2))}</div>,
        },
        {
            title: 'eCPM',
            dataIndex: 'eCPM',
            render: (text: any) => <div className="flex justify-end">${commaSeperator(parseFloat(text).toFixed(2))}</div>,
        },
        {
            title: 'Click Through Rate(CTR)',
            dataIndex: 'CTR',
            render: (text: any) => <div className="flex justify-end">{parseFloat(text).toFixed(2)}%</div>,
        },
        {
            title: 'Ad Impressions',
            dataIndex: 'ad_impressions',
            render: (text: any) => <div className="flex justify-end">{commaSeperator(text)}</div>,
        },
    ];

    useEffect(() => {
        if (pageNo && pageSize && startDate && endDate) {
            const payload = {
                start_dt: startDate,
                end_dt: endDate,
            };
            dispatch(OverAllReportAction.fetchReportSites(pageNo, pageSize, payload));
        }
    }, [dispatch, pageNo, pageSize, startDate, endDate]);
    const handleCampaignPerformanceDownload = () => {
        setDownloadLoader(true);
        const payload = {
            start_dt: startDate,
            end_dt: endDate,
        };

        Apis.exportCampaignPerformance(payload)
            .then(({ data }) => {
                download(data, 'Campaign Performance Report.xlsx');
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ text: String('Something went wrong'), error: true }));
            })
            .finally(() => {
                setDownloadLoader(false);
            });
    };
    return (
        <div className="">
            {/* <div className="flex justify-between">
                <div className="text-[18px] font-[700] font-[Roboto]">Campaign Performances</div>
                <div>
                    <PButton loading={downloadLoader} className="" title={'Export'} onClick={handleCampaignPerformanceDownload} />
                </div>
            </div> */}
            <PCard>
                <PTable loading={campListLoader} columns={columnData} data={campList || []} className="mt-2" rowKey={(c: any) => c._id} />
                <div className="flex justify-end py-2">
                    <Pagination
                        current={pageNo}
                        total={totalRecords}
                        onChange={(e) => setPageNo(e)}
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
                        showSizeChanger={true}
                        onShowSizeChange={(e, i) => setPageSize(i)}
                        pageSizeOptions={[10, 20, 50, 100]}
                    />
                </div>
            </PCard>
        </div>
    );
};

export default SitePerformanceTable;
